import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const UnionIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.80278 3.86708C9.92917 3.60478 10 3.31066 10 3C10 2.75308 9.95525 2.51662 9.87343 2.29827C9.58922 1.53984 8.85765 1 8 1C7.14235 1 6.41078 1.53984 6.12657 2.29827L6.12136 2.31233C6.04285 2.52676 6 2.75838 6 3C6 3.31346 6.07211 3.61007 6.20065 3.87416C6.52505 4.54067 7.20889 5 8 5C8.79111 5 9.47495 4.54067 9.79935 3.87416L9.80278 3.86708Z"
		></path>
		<path
			fill="currentColor"
			d="M10.2458 4.09961C10.9322 4.49569 11.5043 5.06777 11.9004 5.75419C12.2322 5.5914 12.6054 5.5 13 5.5C13.163 5.5 13.3223 5.51559 13.4765 5.54537C12.8748 4.20478 11.7952 3.12524 10.4546 2.52345C10.4844 2.67772 10.5 2.83704 10.5 3C10.5 3.39456 10.4086 3.76777 10.2458 4.09961Z"
		></path>
		<path
			fill="currentColor"
			d="M13 10C13.2469 10 13.4834 9.95525 13.7017 9.87343C14.4602 9.58922 15 8.85765 15 8C15 7.14235 14.4602 6.41078 13.7017 6.12657C13.4834 6.04475 13.2469 6 13 6C12.6865 6 12.3899 6.07211 12.1258 6.20065C11.4593 6.52506 11 7.20889 11 8C11 8.79111 11.4593 9.47495 12.1258 9.79935C12.3899 9.92789 12.6865 10 13 10Z"
		></path>
		<path
			fill="currentColor"
			d="M11.9004 10.2458C12.2322 10.4086 12.6054 10.5 13 10.5C13.163 10.5 13.3223 10.4844 13.4765 10.4546C12.8748 11.7952 11.7952 12.8748 10.4546 13.4765C10.4844 13.3223 10.5 13.163 10.5 13C10.5 12.6054 10.4086 12.2322 10.2458 11.9004C10.9322 11.5043 11.5043 10.9322 11.9004 10.2458Z"
		></path>
		<path
			fill="currentColor"
			d="M6.20065 12.1258C6.52506 11.4593 7.20889 11 8 11C8.79111 11 9.47495 11.4593 9.79935 12.1258C9.92789 12.3899 10 12.6865 10 13C10 13.2469 9.95525 13.4834 9.87343 13.7017C9.58922 14.4602 8.85765 15 8 15C7.14235 15 6.41078 14.4602 6.12657 13.7017C6.04475 13.4834 6 13.2469 6 13C6 12.6865 6.07211 12.3899 6.20065 12.1258Z"
		></path>
		<path
			fill="currentColor"
			d="M5.75419 11.9004C5.06777 11.5043 4.49569 10.9322 4.09961 10.2458C3.76777 10.4086 3.39456 10.5 3 10.5C2.83704 10.5 2.67772 10.4844 2.52345 10.4546C3.12524 11.7952 4.20478 12.8748 5.54537 13.4765C5.51559 13.3223 5.5 13.163 5.5 13C5.5 12.6054 5.5914 12.2322 5.75419 11.9004Z"
		></path>
		<path
			fill="currentColor"
			d="M1 8C1 7.14235 1.53984 6.41078 2.29827 6.12657C2.51662 6.04475 2.75308 6 3 6C3.31346 6 3.61007 6.07211 3.87416 6.20065C4.54067 6.52506 5 7.20889 5 8C5 8.79111 4.54067 9.47495 3.87416 9.79935C3.61007 9.92789 3.31346 10 3 10C2.75308 10 2.51662 9.95525 2.29827 9.87343C1.53984 9.58922 1 8.85765 1 8Z"
		></path>
		<path
			fill="currentColor"
			d="M4.0996 5.75418C3.76776 5.5914 3.39455 5.5 3 5.5C2.83704 5.5 2.67772 5.51559 2.52345 5.54537C3.12523 4.20479 4.20479 3.12523 5.54537 2.52345C5.51559 2.67772 5.5 2.83704 5.5 3C5.5 3.39455 5.5914 3.76776 5.75418 4.0996C5.06777 4.49569 4.49569 5.06777 4.0996 5.75418Z"
		></path>
	</svg>
))
